module.exports = __webpack_public_path__ + "img/government-research-dark.831f3f2c.webp";